import { Component, OnInit, Input, Inject, forwardRef } from '@angular/core';
import { AppComponent } from '../../app.component';
import { PadraoService } from '../../service/padrao.service';
import { bObservableUsuario } from '../../util/observable-util';
import { SelectItem } from 'primeng/primeng';

@Component({
    selector: 'profissional-gerenciar-atividades',
    templateUrl: './profissional-gerenciar-atividades.component.html'
})
export class ProfissionalGerenciarAtividadesComponent implements OnInit {
    @Input() cpf: string;
    @Input() labelCodigo: string;
    @Input() codigo: string;
    @Input() mostrarCodigo: boolean = false;
    registro: string;
    nome: string;
    lotacao: string;

    hipoteses: SelectItem[] = [];
    hipotesesLabel: string = '';
    todasHipoteses: any[];
    funcaoExercida: SelectItem[] = [];

    constructor(@Inject(forwardRef(() => AppComponent)) public app: AppComponent,
        private service: PadraoService,
        private observableUser: bObservableUsuario) { }

    ngOnInit() {
        if (!this.cpf) {
            this.observableUser.getValue.subscribe(profissional => {
                var userInfo = profissional.obj;
                this.cpf = userInfo.cpf;
                this.nome = userInfo.nome;
                this.service.ObterDadosRegistroLogado(this.cpf).subscribe((login) => {
                    this.registro = login.numero_registro;
                });
            });
        } else {
            this.service.ObterDadosRegistroLogado(this.cpf).subscribe(data => {
                this.nome = data.nome;
                this.registro = data.numero_registro;
                
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/Componentes/profissional-gerenciar-atividades/profissional-gerenciar-atividades.component.ts